import { setClassName, setAttr } from "../helpers/dom";

import Entities from "./shared/Entities";
import { createState } from "./shared/BasicState";

export default class ToggleButton {
  constructor() {
    this.entities = new Entities("ToggleButton", "[data-toggle-button]", ToggleButton.initSingle, ToggleButton.destroySingle);
  }

  static initSingle(containerEl) {
    const id = containerEl.getAttribute("data-toggle-button");
    const stateId = containerEl.getAttribute("data-toggle-button-state") ?? id;
    const key = containerEl.getAttribute("data-toggle-button-key") ?? true;
    const minOne = containerEl.getAttribute("data-toggle-button-min-one") !== null;
    const disallowToClose = containerEl.getAttribute("data-toggle-button-disallow-to-close") !== null;
    const disablePrevent = containerEl.getAttribute("data-toggle-button-disable-prevent") !== null;
    const isModal = containerEl.getAttribute("data-toggle-button-modal") !== null;

    const activeClass = containerEl.getAttribute("data-toggle-button-class");
    const activeAttr = containerEl.getAttribute("data-toggle-button-attr") ?? "data-active";

    const toggleObj = {
      el: containerEl,
      stateId,
      key,
      activeClass,
      activeAttr,
    };

    let lastKey = containerEl.hasAttribute(activeAttr) ? key : null;

    const state = createState(stateId, lastKey);

    // methods
    function onClick(e) {
      if (!disablePrevent) e.preventDefault();
      if (disallowToClose) {
        if (lastKey === key) return;
      }
      state.set(key);
    }
    containerEl.addEventListener("click", onClick);

    // state
    function onStateChange(nextKey) {
      if (nextKey === lastKey) {
        if (minOne) return;

        ToggleButton.toggle(toggleObj, null);
        lastKey = null;
        return;
      }

      ToggleButton.toggle(toggleObj, nextKey === key);
      lastKey = nextKey;
    }
    state.subscribe(onStateChange);

    function destroy() {
      containerEl.removeEventListener("click", onClick);
      state.unsubscribe(onStateChange);
    }

    return {
      destroy,
    };
  }

  static destroySingle({ entityObj }) {
    entityObj?.destroy();
  }

  static toggle(toggleObj, isActive) {
    ToggleButton.setActive(toggleObj, isActive);
  }

  static setActive(toggleObj, isActive) {
    if (toggleObj.activeClass) setClassName(toggleObj.el, toggleObj.activeClass, isActive);
    setAttr(toggleObj.el, toggleObj.activeAttr, isActive ? "" : null);
  }
}
